import { FormCentralizer } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { RoleForm } from '../_components/RoleForm';
import { useCreateRole } from '../_hooks/role';

export const CreateRolePage: FC = () => {
  const navigate = useNavigate();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const { mutateAsync: createRole } = useCreateRole();

  return (
    <FormCentralizer width={530}>
      <RoleForm
        onSubmit={async (values) => {
          try {
            const res = await createRole(values);

            await Promise.all([
              openMessage('success', t('message-save-completed')),
              (async () => {
                navigate(`/tenant-manager/roles/${res.id}`, {
                  replace: true,
                });
              })(),
            ]);
          } catch {
            await openMessage('error', t('message-save-failed'));
          }
        }}
      />
    </FormCentralizer>
  );
};
